import './ai-chat.scss';
import { setCookie } from '../../assets/js/modules/cookies';
import { setUserSubscribedCookie } from '../../assets/js/modules/authentication';

(($) => {
	window.addEventListener('message', function (event) {
		if (event.data && typeof event.data === 'string') {
			let message;
			try {
				message = JSON.parse(event.data);
			} catch (error) {
				// Invalid JSON format, ignore the message
				return;
			}

			if (message.type === 'email') {
				setUserSubscribedCookie();
			}
		}
	});
})(jQuery);
